import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function HomeValuation() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <section className="relative py-32 overflow-hidden" data-id="element-226">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-227">
        <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop" alt="Luxury Las Vegas Home" className="w-full h-full object-cover" data-id="element-228" />
        <div className="absolute inset-0 bg-charcoal/80 mix-blend-multiply" data-id="element-229"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/50 to-transparent" data-id="element-230"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-232">
          <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-4 block" data-id="element-233">
            Thinking of Selling?
          </span>
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6" data-id="element-234">
            Get a Free <span className="italic text-gold" data-id="element-235">Home Valuation</span>
          </h2>
          <p className="text-lg text-white/80 font-light mb-12 max-w-2xl mx-auto" data-id="element-236">
            Jenny will provide a comprehensive market analysis of your property
            based on recent comparable sales, market trends, and your home's
            unique features.
          </p>

          {isSubmitted ? <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 md:p-12" data-id="element-237">
              <h3 className="text-2xl font-serif text-gold mb-4" data-id="element-238">
                Request Received
              </h3>
              <p className="text-white/90 font-light text-lg" data-id="element-239">
                Thank you. Jenny will contact you within 24 hours with your
                personalized home valuation.
              </p>
            </motion.div> : <form onSubmit={handleSubmit} className="bg-white p-8 md:p-10 shadow-2xl text-left max-w-3xl mx-auto" data-id="element-240">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-241">
                <div className="md:col-span-2" data-id="element-242">
                  <label className="block text-xs uppercase tracking-wider text-charcoal-light mb-2" data-id="element-243">
                    Property Address
                  </label>
                  <input type="text" required placeholder="Enter your street address" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-244" />
                </div>
                <div data-id="element-245">
                  <label className="block text-xs uppercase tracking-wider text-charcoal-light mb-2" data-id="element-246">
                    Your Name
                  </label>
                  <input type="text" required placeholder="Full Name" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-247" />
                </div>
                <div data-id="element-248">
                  <label className="block text-xs uppercase tracking-wider text-charcoal-light mb-2" data-id="element-249">
                    Email Address
                  </label>
                  <input type="email" required placeholder="Email" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-250" />
                </div>
                <div className="md:col-span-2" data-id="element-251">
                  <label className="block text-xs uppercase tracking-wider text-charcoal-light mb-2" data-id="element-252">
                    Phone Number
                  </label>
                  <input type="tel" required placeholder="Phone" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-253" />
                </div>
              </div>
              <button type="submit" className="w-full bg-gold text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300" data-id="element-254">
                Get My Free Valuation
              </button>
            </form>}

          <div className="mt-10 flex flex-wrap justify-center gap-6 text-white/60 text-sm tracking-wider uppercase" data-id="element-255">
            <span data-id="element-256">No Obligation</span>
            <span className="hidden sm:inline" data-id="element-257">•</span>
            <span data-id="element-258">Confidential</span>
            <span className="hidden sm:inline" data-id="element-259">•</span>
            <span data-id="element-260">Expert Analysis</span>
          </div>
        </motion.div>
      </div>
    </section>;
}